import { FC, ReactNode, ComponentProps } from 'react'
import StepIndicator from 'components/features/pfm/StepIndicator/StepIndicator'
import * as isNumber from 'lodash/isNumber'
import * as styles from 'components/features/pfm/GatherHeader/GatherHeader.css'
import Subtitle from 'components/features/pfm/Subtitle/Subtitle'
import cn from 'classnames'

type GatherHeaderProps = {
  step?: ComponentProps<typeof StepIndicator>['step']
  maxStep?: number
  title: ReactNode
  className?: string
}

const GatherHeader: FC<GatherHeaderProps> = (props) => {
  const { title, children, step = null, maxStep, className } = props

  const subtitle = children
    ? (
      <div className={ styles.subtitleWrapper }>
        <Subtitle>{ children }</Subtitle>
      </div>
    )
    : null

  return (
    <header className={ cn(styles.gatherHeader, className) }>
      { step !== null && isNumber(maxStep) && (
        <div className={ styles.progress }>
          <StepIndicator step={ step } maxStep={ maxStep } />
        </div>
      )}
      <h1 className={ styles.title }>
        { title }
      </h1>
      { subtitle }
    </header>
  )
}

export default GatherHeader
